export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>SaaS, 웹 앱 및 파일 공유 서비스를 사용하는 현대의 업무 스타일에 맞는 지능형 기능을 갖춘 핵심 디지털 업무 공간 솔루션입니다.</p><p>모든 앱의 다단계 인증 지원이 가능한 SSO, 마이크로앱 지능형 업무 공간, 맞춤형 피드, 가상 지원, 그리고 무제한 파일 스토리지가 포함된 Citrix Content Collaboration Standard 서비스가 포함됩니다.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>세부적인 보안성이 갖추어진 전체 디지털 업무 공간이 필요하지만, 가상 데스크탑은 필요하지 않은 직원들을 위한 완벽한 업무 공간 솔루션입니다.</p><p>Workspace Standard 기능은 물론 SaaS 및 웹을 위한 고급 보안 제어, 통합 엔드포인트 관리, 그리고 Content Collaboration Premium까지도 포함되어 있습니다.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops를 위한 하이브리드 구축 옵션이 포함된 포괄적 업무 공간 솔루션입니다.</p><p>Workspace Premium 기능은 물론 Citrix Virtual Apps and Desktops용 클라우드 관리 옵션까지 포함되어 있습니다.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials를 통해 중소기업들은 SaaS 및 웹 애플리케이션 로그인 프로세스를 단순화하고 보안을 유지하여 데이터를 보호할 수 있습니다.</p><p>로그인 프로세스의 보안성을 더욱 높여주는 다단계 인증을 사용하는 SaaS 및 웹 애플리케이션 싱글 사인온 기능이 포함되어 있어 계정 침해 가능성을 99.9% 낮추어 줍니다.</p>"
            },
            terms: "*사용자당, 매월",
            btn1: "기능 매트릭스 보기"
        },
        features: {
            disclaimer1: "*3년 가입한 500명의 사용자를 기준으로 사용자당 월 평균 USD/MSRP. 실제 가격은 달라질 수 있습니다. <br /> Citrix Workspace 라이선싱 옵션은 사용자수 25명부터 시작합니다.",
            disclaimer2: "**Workspace 프리미엄 서비스에는 온프레미스 Citrix Virtual Apps and Desktops 구축을 위한 Workspace Analytics가 포함되어 있지 않습니다."
        },
        calculator: {
            edition: "에디션 선택",
            title: "가격 계산",
            users: "사용자 선택",
            estCost: "예상 월 비용",
            btn1: "전문가와 상담하기",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "라이선싱 옵션은 사용자 수 25명부터 시작합니다. 다시 시도하십시오.",
            lowUserMsg: "사용자 수가 500명 미만입니까? 중소 규모의 비즈니스에도 맞게 조정이 가능합니다.",
            volumeDiscount: "사용자 수가 2,500명 이상입니까? 대량 구매 할인 혜택을 이용하십시오.",
            contract1: "1년 계약",
            contract3: "3년 계약",
            contract3savings: "20% 할인",
            term: "사용자당, 매월",
            disclaimer: "*이 계산기는 예산 측정에 도움을 드리기 위한 예상치만을 제공합니다. 실제 가격은 차이가 날 수 있습니다. 해당 할인 혜택은 Citrix 팀 또는 파트너에게 문의하십시오."
        },
        stats: {
            title: "장점",
            stat1: {
                title: "직원 경험의 개선",
                desc: "IT 리더 <b>5명 중 4명</b>은 디지털 혁신과 관련해 직원의 경험이 매우 중요하다고 생각합니다."
            },
            stat2: {
                title: "직원에게 선택권 제공",
                desc: "비즈니스 리더 중 <b>78%</b>는 직원들로 하여금 사용하는 애플리케이션과 기기를 선택할 수 있게 하면 직원 경험을 개선하는 데 도움이 된다는 점에 동의합니다."
            },
            stat3: {
                title: "액세스 단순화",
                desc: "비즈니스 리더 중 <b>47%</b>는 직원 참여에 가장 크게 기여하는 요소가 업무 처리에 필요한 정보를 쉽게 액세스하는 것이라고 말합니다."
            },
            btn1: "전문가와 상담하기",
            disclaimer: "출처: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}